import { upsertTaskFilters } from '@dispatch/shared/services';
import { TasksListFilter } from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';

export const useUpsertTaskListFilter = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>,
  userId: string
) => {
  const { mutate, error, status } = useMutate(
    ['upsert-task-filter', userId],
    (data: TasksListFilter) =>
      upsertTaskFilters(
        {
          ...data,
          userId,
        },
        userId
      ),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    upsertTaskFilters: mutate,
    upsertTaskFilterError: error,
    upsertTaskFilterStatus: status,
  };
};
